{
  "items": [
    {
      "fileName": "GENERIC-HumanNatureMacro-01.mp4",
      "description": "The video shows one person's hand and arm, with a fair skin tone, wearing a top, a white, cream colored knit sweater with ribbed cuffs, along with a gold ring visible on one finger. The hand is gently brushing through tall grass and wheat like plants, with fingers extended and moving through the greenery. The setting is an outdoor open field environment, showing tall green grass, wheat, and seed heads swaying, with additional blurred greenery and a hazy horizon line in the distance. The lighting is bright and warm, consistent with golden hour sunlight, with the sun visible as a bright glowing highlight in the upper right of the frame, creating a soft, hazy glow and warm highlights on the grass and hand. The color palette is warm and golden, dominated by green, tan, and gold tones, with a bright white glow from the sun. The composition is a close up, closeup, side angle framing, with the hand and arm positioned in the left portion of the frame and the grass filling the right portion. The visual style is photographic, realistic, and resembles a lifestyle or nature style stock video with a shallow depth of field and warm, golden backlighting.",
      "keyElements": [
        "grass",
        "wheat",
        "seed heads",
        "field",
        "horizon",
        "sweater color",
        "ring",
        "backlight",
        "lighting"
      ],
      "attributes": [
        "peaceful",
        "serene",
        "candid",
        "close up",
        "closeup",
        "shallow depth of field",
        "golden hour",
        "backlight",
        "warm lighting",
        "natural light",
        "warm tone",
        "hazy",
        "nature",
        "lifestyle",
        "hand",
        "arm",
        "sweater",
        "white",
        "cream",
        "ring",
        "grass",
        "wheat",
        "field",
        "green",
        "gold",
        "sunlight"
      ]
    },
    {
      "fileName": "GENERIC-HumanNatureMacro-02.mp4",
      "description": "The video shows one person's hand and arm, with a fair skin tone, reaching out and gently touching a patch of green moss growing on a tree trunk or rock surface. The fingers are extended, lightly brushing across the soft, textured moss. The setting is an outdoor forest or woodland environment, showing dense green moss covering a vertical surface, along with additional blurred green foliage and gray, stone colored rock in the background. The lighting is soft, cool, and diffused, consistent with shaded forest lighting, evenly illuminating the hand and moss without harsh shadows. The color palette is cool and rich, dominated by green tones in various shades, with gray accents from the rock and fair skin tones from the hand. The composition is a close up, closeup, side angle framing, with the hand positioned in the lower left portion of the frame and the moss covered surface filling the right portion. The visual style is photographic, realistic, and resembles a nature or lifestyle style stock video with a shallow depth of field and a calm, natural look.",
      "keyElements": ["moss", "tree trunk", "rock", "foliage", "lighting"],
      "attributes": [
        "calm",
        "peaceful",
        "serene",
        "candid",
        "close up",
        "closeup",
        "shallow depth of field",
        "soft lighting",
        "cool tone",
        "natural light",
        "nature",
        "forest",
        "woodland",
        "lifestyle",
        "hand",
        "arm",
        "moss",
        "green",
        "gray",
        "rock",
        "tree",
        "foliage",
        "texture"
      ]
    },
    {
      "fileName": "GENERIC-HumanNatureMacro-03.mp4",
      "description": "The video shows one person's hand and arm, appearing as a silhouette, reaching out and brushing through tall wildflowers and dried plants. The hand's fingers are spread and extended, moving gently through the golden colored vegetation. The setting is an outdoor open field or meadow environment, showing tall dried grass, wildflowers, and seed heads in golden and yellow tones, with additional blurred plants and a hazy, bright horizon in the background. The lighting is extremely bright and warm, consistent with strong backlight sunlight low on the horizon, creating a prominent lens flare and glowing highlight in the lower portion of the frame, and silhouetting the hand against the bright light. The color palette is warm and golden, dominated by yellow, gold, and amber tones, with a bright white and green glow from the sun and lens flare. The composition is a close up, closeup, framing, with the silhouetted hand positioned centrally in the frame against the bright, hazy field. The visual style is photographic, realistic, and resembles a nature or lifestyle style stock video with a shallow depth of field, strong backlight, and lens flare.",
      "keyElements": [
        "wildflowers",
        "field",
        "meadow",
        "seed heads",
        "horizon",
        "backlight",
        "lens flare",
        "lighting"
      ],
      "attributes": [
        "peaceful",
        "serene",
        "candid",
        "close up",
        "closeup",
        "silhouette",
        "shallow depth of field",
        "backlight",
        "lens flare",
        "golden hour",
        "warm lighting",
        "natural light",
        "warm tone",
        "hazy",
        "nature",
        "lifestyle",
        "hand",
        "arm",
        "wildflowers",
        "field",
        "meadow",
        "gold",
        "yellow",
        "amber",
        "sunlight"
      ]
    },
    {
      "fileName": "GENERIC-HumanNatureMacro-04.mp4",
      "description": "The video shows one person's hand and arm, with a fair skin tone, wearing a top, a light blue, gray colored sleeve, reaching down from a boat and trailing fingers through calm water, creating small ripples and splashes. The setting is an outdoor lake or river environment, showing calm, rippling water reflecting warm golden light, a hazy tree lined shoreline in the distance, and the edge of a tan, beige colored boat visible on the right side of the frame with a black rope or fastening detail. The lighting is bright and warm, consistent with golden hour sunset or sunrise light, creating strong reflections, sparkling highlights on the water, and a glowing sun visible near the horizon. The color palette is warm and golden, dominated by yellow, gold, and amber tones, with cool blue gray tones in the shadowed water. The composition is a close up, closeup, side angle framing, with the hand and arm positioned in the upper right portion of the frame and the rippling water filling the rest of the frame. The visual style is photographic, realistic, and resembles a lifestyle or nature style stock video with a shallow depth of field and warm, glowing golden hour lighting.",
      "keyElements": [
        "water",
        "ripples",
        "lake",
        "shoreline",
        "trees",
        "boat",
        "rope",
        "sleeve color",
        "lighting"
      ],
      "attributes": [
        "peaceful",
        "serene",
        "candid",
        "close up",
        "closeup",
        "shallow depth of field",
        "golden hour",
        "warm lighting",
        "natural light",
        "warm tone",
        "reflection",
        "sparkle",
        "nature",
        "lifestyle",
        "hand",
        "arm",
        "water",
        "lake",
        "ripples",
        "boat",
        "sunset",
        "sunrise",
        "gold",
        "amber",
        "blue gray"
      ]
    }
  ]
}
